var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{directives:[{name:"thumbnail",rawName:"v-thumbnail",value:(_vm.src),expression:"src"}],on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }